import React, { useCallback } from 'react';
import { PropTypes } from 'prop-types';
// logic
import { useTranslation } from 'react-i18next';
import { showBeamer } from 'analytics/beamer';
// style
import styled from 'styled-components';
// components
import MainMenuButton from 'refactored/ui/nav/mainMenu/MainMenuButton';
import MainMenuSeparator from 'refactored/ui/nav/mainMenu/MainMenuSeparator';

// this button is to open beamer
// the icon is empty because we use the original beamer button
// icon position is set up in 'analytics/beamer/beamerStyles'
const MainMenuNewsButton = ({ className, isCollapsed }) => {
  const { t } = useTranslation(['mainMenu']);

  const text = t('news');
  const icon = <></>;

  const onClick = useCallback(() => {
    showBeamer();
  }, []);

  return (
    <div className={className}>
      <MainMenuSeparator />
      <MainMenuButton
        isCollapsed={isCollapsed}
        text={text}
        icon={icon}
        variant="TEXT_HIDDEN"
        onClick={onClick}
      />
    </div>
  );
};

MainMenuNewsButton.propTypes = {
  isCollapsed: PropTypes.bool,
  className: PropTypes.string,
};

export default styled(MainMenuNewsButton)``;
